import { DialogTrigger } from "@indietabletop/appkit";
import {
  MoreMenu,
  MoreMenuDialogDisclosure,
  MoreMenuSeparator,
} from "../ActionsMenu/ActionsMenu";
import { DeleteWarband } from "./DeleteWarband";
import { DuplicateWarband } from "./DuplicateWarband";
import { EditWarbandDialog } from "./EditWarbandDialog";
import { useIsReadOnly } from "./ReadOnlyContext";

export function WarbandMenu() {
  const isReadOnly = useIsReadOnly();

  if (isReadOnly) {
    return null;
  }

  return (
    <MoreMenu>
      <DialogTrigger>
        <EditWarbandDialog />
        <MoreMenuDialogDisclosure>Rename</MoreMenuDialogDisclosure>
      </DialogTrigger>

      <DialogTrigger>
        <DuplicateWarband />
        <MoreMenuDialogDisclosure>Duplicate</MoreMenuDialogDisclosure>
      </DialogTrigger>

      <MoreMenuSeparator />

      <DialogTrigger>
        <DeleteWarband />
        <MoreMenuDialogDisclosure>Delete</MoreMenuDialogDisclosure>
      </DialogTrigger>
    </MoreMenu>
  );
}
